module.exports = __webpack_public_path__ + "media/images/icons/outlined/taobao-59a0472cd5760b2c658c82893c1332db.svg";